<!--联合结账：订单选择-->
<template>
    <PopForm :state="state" width="990px" body-max-height="560px">
        <template v-slot:title>单号选择</template>
        <div class="search-box">
            <el-input placeholder="请输入单号" v-model="searchValue"
                      @keypress.native="e => {if(e.charCode === 13) initData();}">
                <el-button slot="append" type="primary" @click="initData">&nbsp;&nbsp;搜索&nbsp;&nbsp;</el-button>
            </el-input>
        </div>
        <div class="body">
            <el-table :data="tableData" height="400px" style="width: 100%" ref="selectTable"
                      header-row-class-name="cash-select-table-head" class="order-select-list"
                      @select="handleCurrentChange" @select-all="handleSelectAll" @cell-click="selectedRow"
            >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="order_no" width="150" label="单号">
                    <template slot-scope="data">
                        {{data.row.order_no ? data.row.order_no : ""}}
                    </template>
                </el-table-column>
                <el-table-column prop="pro_desc" label="名称" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="total_price" width="100" label="总价"></el-table-column>
            </el-table>
        </div>
        <template v-slot:foot>
            <div class="foot">
                <div class="btn-box">
                    <div class="count-text">
                        共 {{allOrderNum}} 个订单，当前选中 {{selectedNum}} 个
                    </div>
                    <el-button size="medium" @click="close">取消</el-button>
                    <el-button type="primary" size="medium" @click="selected">下一步</el-button>
                </div>
            </div>
        </template>
    </PopForm>
</template>

<script>
    import obj from "@/js/obj";
    import PopForm from "@/model/PopForm";
    export default {
        name: "CashSelectOrder",
        components: {PopForm},
        model: {
            prop: "state",
            event: "show",
        },
        props: {
            state: {
                type: Boolean,
                default: false
            },
            orderList: {
                type: Array,
                default: []
            },
        },
        data: () => ({
            tableData: [],
            searchValue: "",
            selectedListData: [],

            //统计
            allOrderNum: 0,
            selectedNum: 0,
        }),
        methods: {
            //初始化数据
            initData: function () {
                let tableData = [];
                this.orderList.forEach( (item, key) => {
                    if(this.searchValue !== "" && item.order_no.indexOf(this.searchValue) < 0){
                        //未匹配
                    }else if(!obj.isEmpty(item.pro_list)) {
                        let proName = [];
                        let totalPrice = 0;
                        item.pro_list.forEach(v => {
                            proName.push(v.pro_name);
                            totalPrice += v.total_price;
                        });
                        item.order_key = key;
                        item.total_price = "¥" + totalPrice.toFixed(2);
                        item.pro_desc = proName.join("、");
                        tableData.push(item);
                    }
                });

                this.tableData = tableData;

                obj.unScrollbar(".order-select-list .el-table__body-wrapper");
                this.$nextTick( () => {
                    obj.scrollbar(".order-select-list .el-table__body-wrapper");
                });
            },
            //关闭
            close: function () {
                this.selectedListData = [];
                this.$emit("show", false);
            },
            //确定选择
            selected: function () {
                if(this.selectedListData.length < 1){
                    obj.message.error("请选择结算订单");
                    return false;
                }

                this.$emit("selected", this.selectedListData);
                this.close();
            },

            //全选状态改变
            handleSelectAll: function (item) {
                if(item.length > 0)
                    this.selectedListData = item;
                else
                    this.selectedListData = [];
            },
            //选中状态改变
            handleCurrentChange: function (item) {
                if(item.length > 0)
                    this.selectedListData = item;
                else
                    this.selectedListData = [];
            },
            //点击表格行
            selectedRow: function (data, b) {
                this.$refs.selectTable.toggleRowSelection(data);
            },
        },
        watch: {
            state: function (data) {
                if(data) {
                    let num = 0;
                    if(!obj.isEmpty(this.orderList)){
                        this.orderList.forEach( val => {
                            if(!obj.isEmpty(val.pro_list)) num++;
                        });
                    }
                    this.allOrderNum = num;
                    this.initData();
                }
            },
            selectedListData: function (data) {
                this.selectedNum = data.length;
            }
        }
    }
</script>

<style scoped>
    .search-box{
        padding: 6px 6px 0;
    }
    .search-box .el-input-group{
        width: 380px;
    }
    .title{
        font-size: 16px;
        font-weight: 500;
    }
    .body{
        padding: 16px 6px 0;
        height: 402px;
        overflow: auto;
    }
    .body .el-table, .body .el-table:before{
        background-color: transparent;
        border: none;
    }
    .btn-box{
        /*border-top: 1px solid #eaeaea;*/
        padding: 0 20px 10px;
        text-align: right;
    }
    .count-text{
        display: inline-block;
        float: left;
        line-height: 36px;
    }
    .foot{
        padding-bottom: 6px;
    }
</style>
<style>
    .cash-select-table-head th{
        background-color: #f4f4f4;
    }
    .order-select-list.el-table td, .order-select-list.el-table th{
        padding-top: 9px;
        padding-bottom: 9px;
    }
    .order-select-list .el-table__body{
        width: 100% !important;
    }
    .order-select-list .el-table__row{
        cursor: pointer;
    }
</style>
